import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlMatiDeleteMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlMatiDeleteMutation = { matiDelete: { id: string } };

export type GqlMatiSetOrderMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlMatiSetOrderInput;
}>;


export type GqlMatiSetOrderMutation = { matiSetOrder: Array<{ id: string }> };

export type GqlMatSetNameMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlMatSetNameInput;
}>;


export type GqlMatSetNameMutation = { matSetName: { id: string } };

export type GqlMatSetIsDefaultMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlMatSetIsDefaultInput;
}>;


export type GqlMatSetIsDefaultMutation = { matSetIsDefault: Array<{ id: string }> };

export type GqlMatDeleteMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlMatDeleteMutation = { matDelete: { id: string } };


export const MatiDeleteDocument = gql`
    mutation MatiDelete($companyId: ID!, $id: ID!) {
  matiDelete(companyId: $companyId, id: $id) {
    id
  }
}
    `;
export type GqlMatiDeleteMutationFn = Apollo.MutationFunction<GqlMatiDeleteMutation, GqlMatiDeleteMutationVariables>;

/**
 * __useMatiDeleteMutation__
 *
 * To run a mutation, you first call `useMatiDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatiDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matiDeleteMutation, { data, loading, error }] = useMatiDeleteMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatiDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GqlMatiDeleteMutation, GqlMatiDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMatiDeleteMutation, GqlMatiDeleteMutationVariables>(MatiDeleteDocument, options);
      }
export type MatiDeleteMutationHookResult = ReturnType<typeof useMatiDeleteMutation>;
export type MatiDeleteMutationResult = Apollo.MutationResult<GqlMatiDeleteMutation>;
export type MatiDeleteMutationOptions = Apollo.BaseMutationOptions<GqlMatiDeleteMutation, GqlMatiDeleteMutationVariables>;
export const MatiSetOrderDocument = gql`
    mutation MatiSetOrder($companyId: ID!, $input: MatiSetOrderInput!) {
  matiSetOrder(companyId: $companyId, input: $input) {
    id
  }
}
    `;
export type GqlMatiSetOrderMutationFn = Apollo.MutationFunction<GqlMatiSetOrderMutation, GqlMatiSetOrderMutationVariables>;

/**
 * __useMatiSetOrderMutation__
 *
 * To run a mutation, you first call `useMatiSetOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatiSetOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matiSetOrderMutation, { data, loading, error }] = useMatiSetOrderMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatiSetOrderMutation(baseOptions?: Apollo.MutationHookOptions<GqlMatiSetOrderMutation, GqlMatiSetOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMatiSetOrderMutation, GqlMatiSetOrderMutationVariables>(MatiSetOrderDocument, options);
      }
export type MatiSetOrderMutationHookResult = ReturnType<typeof useMatiSetOrderMutation>;
export type MatiSetOrderMutationResult = Apollo.MutationResult<GqlMatiSetOrderMutation>;
export type MatiSetOrderMutationOptions = Apollo.BaseMutationOptions<GqlMatiSetOrderMutation, GqlMatiSetOrderMutationVariables>;
export const MatSetNameDocument = gql`
    mutation MatSetName($companyId: ID!, $input: MatSetNameInput!) {
  matSetName(companyId: $companyId, input: $input) {
    id
  }
}
    `;
export type GqlMatSetNameMutationFn = Apollo.MutationFunction<GqlMatSetNameMutation, GqlMatSetNameMutationVariables>;

/**
 * __useMatSetNameMutation__
 *
 * To run a mutation, you first call `useMatSetNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatSetNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matSetNameMutation, { data, loading, error }] = useMatSetNameMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatSetNameMutation(baseOptions?: Apollo.MutationHookOptions<GqlMatSetNameMutation, GqlMatSetNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMatSetNameMutation, GqlMatSetNameMutationVariables>(MatSetNameDocument, options);
      }
export type MatSetNameMutationHookResult = ReturnType<typeof useMatSetNameMutation>;
export type MatSetNameMutationResult = Apollo.MutationResult<GqlMatSetNameMutation>;
export type MatSetNameMutationOptions = Apollo.BaseMutationOptions<GqlMatSetNameMutation, GqlMatSetNameMutationVariables>;
export const MatSetIsDefaultDocument = gql`
    mutation MatSetIsDefault($companyId: ID!, $input: MatSetIsDefaultInput!) {
  matSetIsDefault(companyId: $companyId, input: $input) {
    id
  }
}
    `;
export type GqlMatSetIsDefaultMutationFn = Apollo.MutationFunction<GqlMatSetIsDefaultMutation, GqlMatSetIsDefaultMutationVariables>;

/**
 * __useMatSetIsDefaultMutation__
 *
 * To run a mutation, you first call `useMatSetIsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatSetIsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matSetIsDefaultMutation, { data, loading, error }] = useMatSetIsDefaultMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatSetIsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<GqlMatSetIsDefaultMutation, GqlMatSetIsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMatSetIsDefaultMutation, GqlMatSetIsDefaultMutationVariables>(MatSetIsDefaultDocument, options);
      }
export type MatSetIsDefaultMutationHookResult = ReturnType<typeof useMatSetIsDefaultMutation>;
export type MatSetIsDefaultMutationResult = Apollo.MutationResult<GqlMatSetIsDefaultMutation>;
export type MatSetIsDefaultMutationOptions = Apollo.BaseMutationOptions<GqlMatSetIsDefaultMutation, GqlMatSetIsDefaultMutationVariables>;
export const MatDeleteDocument = gql`
    mutation MatDelete($companyId: ID!, $id: ID!) {
  matDelete(companyId: $companyId, id: $id) {
    id
  }
}
    `;
export type GqlMatDeleteMutationFn = Apollo.MutationFunction<GqlMatDeleteMutation, GqlMatDeleteMutationVariables>;

/**
 * __useMatDeleteMutation__
 *
 * To run a mutation, you first call `useMatDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matDeleteMutation, { data, loading, error }] = useMatDeleteMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GqlMatDeleteMutation, GqlMatDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlMatDeleteMutation, GqlMatDeleteMutationVariables>(MatDeleteDocument, options);
      }
export type MatDeleteMutationHookResult = ReturnType<typeof useMatDeleteMutation>;
export type MatDeleteMutationResult = Apollo.MutationResult<GqlMatDeleteMutation>;
export type MatDeleteMutationOptions = Apollo.BaseMutationOptions<GqlMatDeleteMutation, GqlMatDeleteMutationVariables>;